import {
  PROMO_CAMPAIGN_LOGIN_FLAG_KEY,
  PROMO_CAMPAIGN_STORAGE_KEY,
} from "../../config/promoCampaign";

const LOGIN_PENDING = "pending";
const LOGIN_SHOWN = "shown";

const readMap = () => {
  try {
    const raw = localStorage.getItem(PROMO_CAMPAIGN_STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
};

export function isPromoCampaignDismissed(campaignId, version) {
  const map = readMap();
  return Number(map[campaignId]) === Number(version);
}

export function dismissPromoCampaign(campaignId, version) {
  try {
    const map = readMap();
    map[campaignId] = Number(version);
    localStorage.setItem(PROMO_CAMPAIGN_STORAGE_KEY, JSON.stringify(map));
  } catch {
    /* private mode / quota */
  }
}

export function markPromoEligibleForLogin() {
  try {
    sessionStorage.setItem(PROMO_CAMPAIGN_LOGIN_FLAG_KEY, LOGIN_PENDING);
  } catch {
    /* private mode */
  }
}

export function isPromoPendingForLogin() {
  try {
    return sessionStorage.getItem(PROMO_CAMPAIGN_LOGIN_FLAG_KEY) === LOGIN_PENDING;
  } catch {
    return false;
  }
}

/** Call when the popup actually opens so remounts (Daily Log back) do not show it again. */
export function markPromoShownForLogin() {
  try {
    sessionStorage.setItem(PROMO_CAMPAIGN_LOGIN_FLAG_KEY, LOGIN_SHOWN);
  } catch {
    /* private mode */
  }
}

export function clearPromoLoginFlag() {
  try {
    sessionStorage.removeItem(PROMO_CAMPAIGN_LOGIN_FLAG_KEY);
  } catch {
    /* private mode */
  }
}
